import { connect } from 'react-redux'
import EditEvent from '../components/EditEvent'
import * as api from '../store/api'

const mapStateToProps = (state) => {
    return {
        purchases: state.service.purchases,
        user: state.service.user
    };
}


const mapDispatchToProps = (dispatch) => ({
    checkUserSession: (callback) => { dispatch(api.checkUserSession()).then(callback) },
    fetchClientAndEvent: (clientId, eventId, callback) => {
        dispatch(api.fetchClientAndEvent(clientId, eventId)).then(callback)
    },
    fetchEventReport: (clientId, eventId, callback) => {
        dispatch(api.fetchEventReport(clientId, eventId)).then(callback)
    },
    updateMaxPrizePoolAndDrawDate: (data, callback) => {
        dispatch(api.updateMaxPrizePoolAndDrawDate(data)).then(callback)
    },
    updateEvent: (data, callback) => {
        dispatch(api.updateEvent(data)).then(callback)
    },
    manualDraw: (data, callback) => {
        dispatch(api.manualDraw(data)).then(callback)
    },
    searchPurchases: (phone, eventId, callback) => {
        dispatch(api.searchPurchases(phone, eventId)).then(callback)
    },
    updatePurchase: (data, callback) => {
        dispatch(api.updatePurchase(data)).then(callback)
    },
    refundPurchase: (data, callback) => {
        dispatch(api.refundPurchase(data)).then(callback)
    }
})


export default connect(mapStateToProps, mapDispatchToProps)(EditEvent)
